import apiWorker from '../apiWorker'

const _signing_documents = {
    create : (data) => apiWorker('post',  `/v1/signing/events`, data, true),
}

export default _signing_documents